import React from 'react';

function TransactionLine({transaction}) {
    // Function to determine status badge styling
    const getStatusBadgeClass = (status) => {
        status = status?.toLowerCase() || '';

        if (status.includes('success') || status.includes('approved') || status.includes('completed')) {
            return 'bg-green-100 text-green-700 border border-green-200';
        } else if (status.includes('pending') || status.includes('processing')) {
            return 'bg-yellow-100 text-yellow-700 border border-yellow-200';
        } else if (status.includes('fail') || status.includes('error') || status.includes('declined')) {
            return 'bg-red-100 text-red-700 border border-red-200';
        } else if (status.includes('refund')) {
            return 'bg-purple-100 text-purple-700 border border-purple-200';
        } else {
            return 'bg-gray-100 text-gray-700 border border-gray-200';
        }
    };

    // Format date if available
    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (e) {
            return dateString;
        }
    };

    return (
        <tr key={transaction?.id} className="hover:bg-gray-50 transition-colors duration-150">
            <td className="whitespace-nowrap px-4 py-4 first:pl-6 text-sm font-medium text-gray-800">{transaction?.merchantReference ?? ''}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600 font-mono">{transaction?.transactionId ?? ''}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600 font-mono">{transaction?.authCode ?? ''}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600 font-mono">{transaction?.cardNumber ?? ''}</td>
            <td className="whitespace-nowrap px-4 py-4 text-sm">
                <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium ${getStatusBadgeClass(transaction?.status)}`}>
                    {transaction?.status ?? ''}
                </span>
            </td>
            <td className="px-4 py-4 text-sm text-gray-600 max-w-xs">
                <div className="line-clamp-2">{transaction?.description ?? ''}</div>
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-gray-600">{formatDate(transaction?.createdAt)}</td>
        </tr>
    );
}

export default TransactionLine;
